export class DataLoggerFormModel {
  id?: number;
  active?: boolean = true;
  identifier?: string;
  macAddress?: string;
  serialNumber?: string;
  facility?: number;
  version?: number;

  constructor(
    id?: number,
    active: boolean = true,
    identifier?: string,
    macAddress?: string,
    serialNumber?: string,
    facility?: number,
    version?: number
  ) {
    this.id = id;
    this.active = active;
    this.identifier = identifier;
    this.macAddress = macAddress;
    this.serialNumber = serialNumber;
    this.facility = facility;
    this.version = version;
  }
}
